/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { createPinia } from "pinia";
import router from "@/router";
import i18n from "./i18n";

// Types
import type { App } from "vue";

export function registerPlugins(app: App) {
	app.use(router);
	app.use(createPinia());
	app.use(i18n);
}
